module.exports = " <div class=content> <div class=\"infor b04\"> <a v-link=\"{name:'zhihu'}\"><i>Zhihu</i></a> </div> <div class=\"infor b05\"> <a @click=jj()><i>Douban</i></a> </div> <div class=\"infor b06\"> <a @click=jj()><i>Others</i></a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/Knowledge.vue
 ** module id = 18
 ** module chunks = 1
 **/